/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const adDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	campaignId: z.string(),
	target: z.string(),
	cta: z.string(),
	location: z.string(),
	metaCallToAction: z.string(),
	metaDescription: z.string(),
	metaHeadline: z.string(),
	metaPrimaryText: z.string(),
	subtitle: z.string(),
	title: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type AdDataSchema = z.infer<typeof adDataSchema>
